package com.vamvisions.main.portfolio.di

import com.vamvisions.main.core.domain.preferences.Language
import com.vamvisions.main.portfolio.data.remote.PortfolioApi
import com.vamvisions.main.portfolio.data.repository.RemoteDocumentRepository
import com.vamvisions.main.portfolio.data.repository.RemoteExperienceRepository
import com.vamvisions.main.portfolio.data.repository.RemoteProjectRepository
import com.vamvisions.main.portfolio.domain.repository.DocumentRepository
import com.vamvisions.main.portfolio.domain.repository.ExperienceRepository
import com.vamvisions.main.portfolio.domain.repository.ProjectRepository
import com.vamvisions.main.portfolio.presentation.document.DocumentViewModel
import com.vamvisions.main.portfolio.presentation.portfolio.PortfolioViewModel
import com.vamvisions.main.portfolio.presentation.projects.ProjectsViewModel
import org.koin.core.module.dsl.bind
import org.koin.core.module.dsl.factoryOf
import org.koin.core.module.dsl.singleOf
import org.koin.dsl.module

/**
 * ViewModels are factories for the same reason as in `corePresentationModule`. [DocumentViewModel]
 * takes the route's slug and language as parameters.
 */
val portfolioModule = module {
    singleOf(::PortfolioApi)
    singleOf(::RemoteProjectRepository) { bind<ProjectRepository>() }
    singleOf(::RemoteExperienceRepository) { bind<ExperienceRepository>() }
    singleOf(::RemoteDocumentRepository) { bind<DocumentRepository>() }
    factoryOf(::PortfolioViewModel)
    factoryOf(::ProjectsViewModel)
    factory { (slug: String, language: Language) -> DocumentViewModel(slug, language, get()) }
}
